export class UsageTypeReferenceModel {
    public usageTypeCode: string;
    public usageTypeName: string;
    public sortSequence: number;
}